import MissingSkus from '@/views/tables/missingskus'
import MissingCodles from '@/views/tables/missingcodles'
import ProductsTable from '@/views/tables/products'
import ClientsTable from '@/views/tables/clients'
import SalesTable from '@/views/tables/sales'
import ImportBatches from '@/views/tables/imports'
import ImportResults from '@/views/tables/imports_results'
import ImportResultsView from '@/views/tables/import_result_view'
import SettingsEdit from '@/views/settings/SettingsEdit'
import GridTable from '@/views/tables/grid'

export default {
  path: '/tables',
  redirect: '/tables/missing-skus',
  name: 'tables',
  meta: {
    auth: true,
    label: 'Tabelas'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'missing-skus',
    name: 'tables.missing-skus',
    component: MissingSkus,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'missing-codles',
    name: 'tables.missing-codles',
    component: MissingCodles,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'settings',
    name: 'tables.settings',
    component: SettingsEdit,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'import-batches',
    name: 'tables.import-batches',
    component: ImportBatches,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'import-batches/results/:id',
    name: 'tables.import-results',
    component: ImportResults,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'import-batches/results/:id/:detailId',
    name: 'tables.import-results-view',
    component: ImportResultsView,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'mpg',
    name: 'tables.mpg',
    component: GridTable,
    props: {
      url: 'tables/mpg',
      name: 'Gamas',
      tablename: 'Mpg'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'brands',
    name: 'tables.brands',
    component: GridTable,
    props: {
      url: 'tables/brands',
      name: 'Marcas',
      tablename: 'Brands'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'prodaggregs',
    name: 'tables.prodaggregs',
    component: GridTable,
    props: {
      url: 'tables/prodaggregs',
      name: 'ProdAgregs',
      tablename: 'Prodagreggs'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'cores',
    name: 'tables.cores',
    component: GridTable,
    props: {
      url: 'tables/cores',
      name: 'Core',
      tablename: 'Core'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'products',
    name: 'tables.products',
    component: ProductsTable,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'clients',
    name: 'tables.clients',
    component: ClientsTable,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'activities',
    name: 'tables.activities',
    component: GridTable,
    props: {
      url: 'tables/activities',
      name: 'Tipos de Actividade',
      tablename: 'activityTypes'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'operatorgroups',
    name: 'tables.operatorgroups',
    component: GridTable,
    props: {
      url: 'tables/operatorgroups',
      name: 'Grupos de Operadores',
      tablename: 'operatorgroups'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'visibilities',
    name: 'tables.visibilities',
    component: GridTable,
    props: {
      url: 'tables/visibilities',
      name: 'Visibilidades',
      tablename: 'visibilities'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'sales',
    name: 'tables.sales',
    component: SalesTable,
    props: {
      url: 'tables/sales',
      name: 'Visibilidades',
      tablename: 'sales'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }]
}



// WEBPACK FOOTER //
// ./src/views/tables/missingRouter.js